import { STATUS, WORKFLOW_ACTIONS_ACTION } from "../constant";

const initState = {
  workflowActionsData: null,
  workflowStateCategoryData: null,
  workflowStateData: null,
  workflowData: null,
  workflowtype: null,

  isLoading: null,

  createActionsSuccess: null,
  deleteActionsSuccess: null,

  createStateCategorySuccess: null,
  deleteStateCategorySuccess: null,

  createStateSuccess: null,
  deleteStateSuccess: null
};

export default function(state = initState, action) {
  switch (action.type) {
    case WORKFLOW_ACTIONS_ACTION.FETCH_WORKFLOW_ACTIONS_START:
      return { ...state, isLoading: STATUS.LOADING };
    case WORKFLOW_ACTIONS_ACTION.FETCH_WORKFLOW_ACTIONS_SUCCESS: {
      return {
        ...state,
        workflowActionsData: action.payload,
        isLoading: STATUS.SUCCESS
      };
    }
    case WORKFLOW_ACTIONS_ACTION.FETCH_WORKFLOW_ACTIONS_FAILURE:
      return { ...state, isLoading: STATUS.ERROR };

    case WORKFLOW_ACTIONS_ACTION.CREATE_WORKFLOW_ACTION_START:
      return { ...state, isLoading: STATUS.LOADING };
    case WORKFLOW_ACTIONS_ACTION.CREATE_WORKFLOW_ACTION_SUCCESS: {
      return {
        ...state,
        createActionsSuccess: action.payload,
        isLoading: STATUS.SUCCESS
      };
    }
    case WORKFLOW_ACTIONS_ACTION.CREATE_WORKFLOW_ACTION_FAILURE:
      return { ...state, isLoading: STATUS.ERROR };

    case WORKFLOW_ACTIONS_ACTION.DELETE_WORKFLOW_ACTION_START:
      return { ...state, isLoading: STATUS.LOADING };
    case WORKFLOW_ACTIONS_ACTION.DELETE_WORKFLOW_ACTION_SUCCESS: {
      return {
        ...state,
        deleteActionsSuccess: action.payload,
        isLoading: STATUS.SUCCESS
      };
    }
    case WORKFLOW_ACTIONS_ACTION.DELETE_WORKFLOW_ACTION_FAILURE:
      return { ...state, isLoading: STATUS.ERROR };

    case WORKFLOW_ACTIONS_ACTION.FETCH_WORKFLOW_STATE_CATEGORY_START:
      return { ...state, isLoading: STATUS.LOADING };
    case WORKFLOW_ACTIONS_ACTION.FETCH_WORKFLOW_STATE_CATEGORY_SUCCESS: {
      return {
        ...state,
        workflowStateCategoryData: action.payload,
        isLoading: STATUS.SUCCESS
      };
    }
    case WORKFLOW_ACTIONS_ACTION.FETCH_WORKFLOW_STATE_CATEGORY_FAILURE:
      return { ...state, isLoading: STATUS.ERROR };

    case WORKFLOW_ACTIONS_ACTION.CREATE_WORKFLOW_STATE_CATEGORY_START:
      return { ...state, isLoading: STATUS.LOADING };
    case WORKFLOW_ACTIONS_ACTION.CREATE_WORKFLOW_STATE_CATEGORY_SUCCESS: {
      return {
        ...state,
        createStateCategorySuccess: action.payload,
        isLoading: STATUS.SUCCESS
      };
    }
    case WORKFLOW_ACTIONS_ACTION.CREATE_WORKFLOW_STATE_CATEGORY_FAILURE:
      return { ...state, isLoading: STATUS.ERROR };

    case WORKFLOW_ACTIONS_ACTION.DELETE_WORKFLOW_STATE_CATEGORY_START:
      return { ...state, isLoading: STATUS.LOADING };
    case WORKFLOW_ACTIONS_ACTION.DELETE_WORKFLOW_STATE_CATEGORY_SUCCESS: {
      return {
        ...state,
        deleteStateCategorySuccess: action.payload,
        isLoading: STATUS.SUCCESS
      };
    }
    case WORKFLOW_ACTIONS_ACTION.DELETE_WORKFLOW_STATE_CATEGORY_FAILURE:
      return { ...state, isLoading: STATUS.ERROR };

    case WORKFLOW_ACTIONS_ACTION.FETCH_WORKFLOW_STATE_START:
      return { ...state, isLoading: STATUS.LOADING };
    case WORKFLOW_ACTIONS_ACTION.FETCH_WORKFLOW_STATE_SUCCESS: {
      return {
        ...state,
        workflowStateData: action.payload,
        isLoading: STATUS.SUCCESS
      };
    }
    case WORKFLOW_ACTIONS_ACTION.FETCH_WORKFLOW_STATE_FAILURE:
      return { ...state, isLoading: STATUS.ERROR };

    case WORKFLOW_ACTIONS_ACTION.CREATE_WORKFLOW_STATE_START:
      return { ...state, isLoading: STATUS.LOADING };
    case WORKFLOW_ACTIONS_ACTION.CREATE_WORKFLOW_STATE_SUCCESS: {
      return {
        ...state,
        createStateSuccess: action.payload,
        isLoading: STATUS.SUCCESS
      };
    }
    case WORKFLOW_ACTIONS_ACTION.CREATE_WORKFLOW_STATE_FAILURE:
      return { ...state, isLoading: STATUS.ERROR };

    case WORKFLOW_ACTIONS_ACTION.DELETE_WORKFLOW_STATE_START:
      return { ...state, isLoading: STATUS.LOADING };
    case WORKFLOW_ACTIONS_ACTION.DELETE_WORKFLOW_STATE_SUCCESS: {
      return {
        ...state,
        deleteStateSuccess: action.payload,
        isLoading: STATUS.SUCCESS
      };
    }
    case WORKFLOW_ACTIONS_ACTION.DELETE_WORKFLOW_STATE_FAILURE:
      return { ...state, isLoading: STATUS.ERROR };

    case WORKFLOW_ACTIONS_ACTION.FETCH_WORKFLOW_START:
      return { ...state, isLoading: STATUS.LOADING };
    case WORKFLOW_ACTIONS_ACTION.FETCH_WORKFLOW_SUCCESS: {
      return {
        ...state,
        workflowData: action.payload,
        isLoading: STATUS.SUCCESS
      };
    }
    case WORKFLOW_ACTIONS_ACTION.FETCH_WORKFLOW_FAILURE:
      return { ...state, isLoading: STATUS.ERROR };

    case WORKFLOW_ACTIONS_ACTION.WORKFLOW_TYPE_START:
      return { ...state, isLoading: STATUS.LOADING };
    case WORKFLOW_ACTIONS_ACTION.WORKFLOW_TYPE_SUCCESS: {
      return {
        ...state,
        workflowtype: action.payload,
        isLoading: STATUS.SUCCESS
      };
    }
    case WORKFLOW_ACTIONS_ACTION.WORKFLOW_TYPE_FAILURE:
      return { ...state, isLoading: STATUS.ERROR };

    case WORKFLOW_ACTIONS_ACTION.CREATE_WORKFLOW_START:
      return { ...state, isLoading: STATUS.LOADING };
    case WORKFLOW_ACTIONS_ACTION.CREATE_WORKFLOW_SUCCESS: {
      return {
        ...state,
        createWorkflowSuccess: action.payload,
        isLoading: STATUS.SUCCESS
      };
    }
    case WORKFLOW_ACTIONS_ACTION.CREATE_WORKFLOW_FAILURE:
      return { ...state, isLoading: STATUS.ERROR };

    case WORKFLOW_ACTIONS_ACTION.FETCH_WORKFLOW_STATE_FOR_CENTRAL_START:
      return { ...state, isLoading: STATUS.LOADING };

    case WORKFLOW_ACTIONS_ACTION.FETCH_WORKFLOW_STATE_FOR_CENTRAL_SUCCESS: {
      return {
        ...state,
        workflowStateDataForCentral: action.payload,
        isLoading: STATUS.SUCCESS
      };
    }
    case WORKFLOW_ACTIONS_ACTION.FETCH_WORKFLOW_STATE_FOR_CENTRAL_FAILURE:
      return { ...state, isLoading: STATUS.ERROR };

    default:
      return state;
  }
}
